angular.module('app.directives').directive('vpNotifications', ($templateCache, $interpolate) => {
    const template = $templateCache.get('/app/header/notifications.html');
    const interpolated = $interpolate(template)();
    const compiled = _.template(interpolated);
    const maxItems = 99;

    return {
        restrict: 'A',
        scope: {},
        bindToController: {},
        //template: '<a class="user_action_icon"><i class="material-icons md-24 md-light">notifications</i></a>',
        templateUrl: '/app/header/notifications.html',
        controllerAs: 'notifications',
        controller($interval, $state, UserService, api) {
            const vm = this;
            const notificationListModel = api('notifications/user');

            vm.notificationsLoaded = false;
            vm.notificationsCount = '-';
            vm.notifications = [];

            vm.getNotifications = () => {
                vm.notificationsLoaded = false;
                notificationListModel.get(UserService.getUser().id).then((response) => {
                    vm.notifications = _.slice(response, 0, maxItems);
                    vm.notificationsLoaded = true;

                    vm.notificationsCount = maxItems < vm.notifications.length ? `${maxItems}+` : vm.notifications.length;
                    vm.iconClassName = vm.getIconClassName();
                });
            };

            vm.getIconClassName = () => {
                switch (true) {
                    case vm.notifications.length < 5: {
                        return 'uk-badge-info';
                    }
                    case vm.notifications.length < 20: {
                        return 'uk-badge-warning';
                    }
                    default: {
                        return 'uk-badge-danger';
                    }
                }
            };

            // sprawdzamy powiadomienia co minutę
            vm.getNotifications();
            $interval(() => {
                vm.getNotifications();
            }, 600 * 1000); // co 10 min

            vm.setNotificationAsReaded = (id) => {
                const notificationModel = api(`notifications/${id}`);

                notificationModel
                    .post({
                        readed: true,
                    })
                    .then(() => {
                        const i = _.findIndex(vm.notifications, { id: id });

                        if (-1 < i) {
                            vm.notifications.splice(i, 1);
                            vm.notificationsCount = maxItems < vm.notifications.length ? `${maxItems}+` : vm.notifications.length;
                            notificationModel.clearCache();
                        }
                    });
            };

            vm.setAllNotificationsAsReaded = () => {
                const notificationModel = api('notifications/all');

                notificationModel
                    .post({
                        readed: true,
                    })
                    .then(() => {
                        vm.notifications = [];
                        vm.notificationsCount = 0;
                        notificationModel.clearCache();
                    });
            };

            vm.goTo = (model, modelId) => {
                const state = $state.get(`restricted.${model}_edit`);
                if (state) {
                    $state.go(state, { id: modelId });
                }
            };
        },
    };
});
